import React from "react";
import { DashboardRenderSalesforceEntity } from "../dashboard-render-salesforce-entity/dashboard-render-salesforce-entity";

export function DashboardRenderSalesforce() {
  return function (info: any) {
    const link = info?.getValue();
    return <DashboardRenderSalesforceEntity link={link} />;
  };
}
